module.exports = __webpack_public_path__ + "img/Logo-transparent_old.e0743e9b.png";